// available contexts for the core-file-notes to define some behaviours
export const CTX = {
    DEFAULT: 'default',
    APP_ARTWORK_DETAILS: 'app-artwork-details', // not any share feature in the artwork
    APP_ARTWORK_DETAILS_FEEDBACK: 'app-artwork-details-feedback',
    MESSAGE_FEEDBACK: 'message-share-feedback',
    MESSAGE_DEFAULT: 'message-default',
    SHARE_ARTWORK_DETAILS_FEEDBACK: 'share-artwork-details-feedback', // share feedback feature in the artwork
};
  